
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalServiceGroupsCount }}</span>
          <span class="stats-card-label">Total Service Groups</span>
          <span class="stats-card-sublabel">All service groups</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-sitemap"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeServiceGroupsCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveServiceGroupsCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredServiceGroups"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} service groups"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sortIcon field="name" />
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description" />
          </th>
          <th pSortableColumn="notificationEmails">
            Contract Email Recipients
            <i class="pi pi-info-circle th-info"
               pTooltip="Read-only here. Edit these under Administration → Notification Settings, in the Contracts section."
               tooltipPosition="top"></i>
            <p-sortIcon field="notificationEmails" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-serviceGroup>
        <tr [class.row-inactive]="serviceGroup.isActive === false">
          <td class="td-truncate" [pTooltip]="serviceGroup.name || '-'" tooltipPosition="top">{{ serviceGroup.name }}</td>
          <td class="td-truncate td-description" [pTooltip]="(serviceGroup.description || '-')" tooltipPosition="top">{{ serviceGroup.description || '-' }}</td>
          <td class="td-truncate" [pTooltip]="(serviceGroup.notificationEmails || 'No service group head configured')" tooltipPosition="top">{{ notificationRecipientNames(serviceGroup) || '-' }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="serviceGroup.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="serviceGroup.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(serviceGroup)"
                size="small"
                [pTooltip]="serviceGroup.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(serviceGroup)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="4" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No service groups found</p>
              <p class="empty-description">Update filters or add a new service group</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Service Group' : 'Edit Service Group'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedServiceGroup.name.trim()">
          <label for="name">Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedServiceGroup.name"
            placeholder="Enter service group name" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedServiceGroup.name.trim()">Name is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedServiceGroup.description" rows="3"
            class="p-inputtext" placeholder="Enter service group description"></textarea>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedServiceGroup.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedServiceGroup.isActive ? 'success' : 'secondary'"
            [outlined]="!selectedServiceGroup.isActive"
            (onClick)="selectedServiceGroup.isActive = !selectedServiceGroup.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetServiceGroupForm()" [text]="true" severity="secondary"
        styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveServiceGroup()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
